import SchoolInterface from './SchoolInterface';

export const validStatus = {
  OPEN: { value: 'OPEN', color: 'success' },
  PENDING: { value: 'PENDING', color: 'warning' },
  CLOSED: { value: 'CLOSED', color: 'danger' },
};

export enum statusEnum {
  OPEN = 'OPEN',
  PENDING = 'PENDING',
  CLOSED = 'CLOSED',
}

export interface SupportQuestionAnswer {
  question: string;
  answer: string;
}

export interface SupportAttachment {
  name: string;
  mimetype: string;
  url: string;
}

export interface SupportListInterface {
  id: string;
  schoolId?: string;
  department: string;
  priority: string;
  description: string;
  type: string;
  status: string;
  user: any;
  attachments?: SupportAttachment[];
  createdAt: Date;
  updatedAt: Date;
  requests: any[];
  questionAnswers?: SupportQuestionAnswer[];
  subcategory?: string;
  school?: SchoolInterface;
}

export default SupportListInterface;
